angular.module('smartorg.r6.acts.commonData', []);
require('./common-data-directive');
module.exports = 'smartorg.r6.acts.commonData';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/common-data/app/js/plumbing/app.js